export default __webpack_public_path__ + "static/media/imagem_07.7dc87153.webp";